var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn p-v-8 p-r-10"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }